/* istanbul ignore next */
const ACTIONS = {
    GET_HAS_PPS_LISTINGS: 'GET_HAS_PPS_LISTINGS',
    GET_HAS_PPS_LISTINGS_SUCCESS: 'GET_HAS_PPS_LISTINGS_SUCCESS',
    HAS_PPS_LISTINGS_SERVICE_ERROR: 'HAS_PPS_LISTINGS_SERVICE_ERROR'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    getHasPpsListings() {
        return {
            type: ACTIONS.GET_HAS_PPS_LISTINGS
        };
    },

    getHasPpsListingsSuccess(hasPpsListings) {
        return {
            type: ACTIONS.GET_HAS_PPS_LISTINGS_SUCCESS,
            payload: {
                hasPpsListings
            }
        };
    },

    alertError(errorKey) {
        return {
            type: ACTIONS.HAS_PPS_LISTINGS_SERVICE_ERROR,
            payload: {
                errorKey
            }
        };
    }
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
